import React from 'react'
import Application from '../components/application'
import {ApplicationLoader} from '../decorators/with-data'
import gql from 'graphql-tag'
import {getParams} from '../utilities/route'
import {Query} from 'react-apollo'
import {Route} from 'react-router-dom'
import {Adopt} from 'react-adopt'
import {QUESTIONNAIRE_FRAGMENT} from "../graphql/fragments";

const query = gql`
  query Application($languageCode: String) {
    questionnaire(languageCode: $languageCode) {
        ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`

const mapper = {
    route: <Route/>,
    query: ({render, route}) => <Query query={query} variables={getParams(route, ['languageCode'])}>{render}</Query>
}

export default () => (
    <Adopt mapper={mapper}>
        {({route, query: {data, loading, error}}) => {
          return (
            loading || error ? <ApplicationLoader error={error}/> : <Application {...data} {...route} />
          )
        }}
    </Adopt>
)



// WEBPACK FOOTER //
// ./src/containers/application.js